// import React, { useEffect, useState } from "react";
// import { HiSwitchVertical } from "react-icons/hi";
// import { IoCopy } from "react-icons/io5";
// import Web3 from "web3";
// import { useWeb3ModalAccount } from "@web3modal/ethers/react";

// import chata from "../assets/Group 28.png";
// import bee from "../assets/Group 32.png";
// import smallbee from "../assets/8f3479b9762001f0370cb94e488635a5a1211592.gif";
// import tron from "../assets/image 1.png";
// import capbee from "../assets/Group 25.png";
// import capbee2 from "../assets/6842a7f196a5b2b2149f793f6a3bebf0f3fa9777 (1).gif";
// import capbee22 from "../assets/3939e60ff48ab243dd0431a6300e27947bf4065a.gif";

// import { beeplanABI, beeplanAddress } from "../Contract/BeePlan";
// import { usdtTokenABI, usdtTokenAddress } from "../Contract/USDT";
// import { beeTokenABI, beeTokenAddress } from "../Contract/BeeToken";

// function Info() {
//   const { address: account, chainId } = useWeb3ModalAccount();
//   const isBSC = chainId === 97 || chainId === 56; 
//   const bscScanBase = chainId === 97
//     ? "https://testnet.bscscan.com/tx/"
//     : "https://bscscan.com/tx/";

//   const web3 = new Web3(window.ethereum);
//   const beePlanContract = new web3.eth.Contract(beeplanABI, beeplanAddress);
//   const USDTContract      = new web3.eth.Contract(usdtTokenABI, usdtTokenAddress);
//   const BeeTokenContract  = new web3.eth.Contract(beeTokenABI, beeTokenAddress);

//   const [rows, setRows] = useState([]);
//   const [userSummaries, setUserSummaries] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [roundss, setRoundss] = useState(1);

//   const pageSize = 1; // Show one round at a time

//   const fetchAllUserSummaries = async () => {
//     try {
//       const currentRound = await beePlanContract.methods.currentRound().call();
//       setRoundss(currentRound);
//       const summaries = [];
//       const fmt = v => Number(v) / 1e18;

//       for (let round = roundss; round >= 1; round--) {
//         const data = await beePlanContract.methods.getUserSummary(account, round).call();
//         summaries.push({
//           round,
//           totalSpentUSDT: fmt(data.totalSpentUSDT),
//           totalAvailableUSDT: fmt(data.totalAvailableUSDT),
//           totalReferral: fmt(data.totalReferral),
//           totalSpentBEE: fmt(data.totalSpentBEE),
//           totalAvailableBEE: fmt(data.totalAvailableBEE),
//         });
//       }

//       setUserSummaries(summaries);
//       setCurrentPage(1); // Reset to latest on load
//     } catch (err) {
//       console.error("Error fetching user summaries:", err);
//     }
//   };

//   useEffect(() => {
//     if (account && roundss) {
//       fetchAllUserSummaries();
//     }
//   }, [account, roundss]);

//   const paginatedSummaries = userSummaries.slice(
//     (currentPage - 1) * pageSize,
//     currentPage * pageSize
//   );

//   // Helper: fetch events in chunks
//   const fetchChunkedEvents = async (contract, startBlock, endBlock, chunkSize = 5000) => {
//     let all = [];
//     for (let from = startBlock; from <= endBlock; from += chunkSize) {
//       const to = Math.min(from + chunkSize - 1, endBlock);
//       try {
//         const evs = await contract.getPastEvents("Purchase", {
//           fromBlock: from,
//           toBlock:   to,
//         });
//         all = all.concat(evs);
//       } catch (err) {
//         console.error(`Error fetching blocks ${from}–${to}:`, err);
//       }
//     }
//     return all;
//   };

//   // Fetch Purchase events, chunked, then format & setRows
//   const fetchContractEvents = async () => {
//     try {
//       // <-- force latestBlock into a JS Number
//       const latestBlock = Number(await web3.eth.getBlockNumber());
//       const fromBlock   = Math.max(0, latestBlock - 10000);

//       const events = await fetchChunkedEvents(
//         beePlanContract,
//         fromBlock,
//         latestBlock,
//         5000
//       );

//       const formatted = events
//         .map(e => ({
//           round:       e.returnValues.round.toString(),
//           orderNo:     e.returnValues.queueId.toString(),
//           exitNo:      e.returnValues.exitTrigger.toString(),
//           blockNumber: e.blockNumber,
//           txid:        e.transactionHash,
//         }))
//         .reverse();
// console.log("formatted",formatted);

//       setRows(formatted);
//     } catch (error) {
//       console.error("Error fetching contract events:", error);
//     }
//   };

//   useEffect(() => {
//     fetchContractEvents();
//     const iv = setInterval(fetchContractEvents, 30_000);
//     return () => clearInterval(iv);
//   }, []);
//   return (
//     <div>
//       <div className="row m-0 p-0">
//         <div className="col-12 col-md-2 p-0 flexx">
//           <img src={capbee2} alt="" className="w-100 pt-5" />
//           <img src={smallbee} alt="" className="smabeer mt-5" width={100} height={100} />
//         </div>

//         <div className="col-12 col-md-8 tree">
//           <h2 className="fw-bolder fs-1 text-center mb-3 mt-5 mt-md-1">
//             My Information
//           </h2>
//           <p
//             className="fs-5 text-center"
//             style={{ letterSpacing: "1px", wordBreak: "break-all" }}
//           >
//             Wallet Address: {account || "Not connected"}
//           </p>

//           {paginatedSummaries.map((summary) => (
//         <div key={summary.round} className="mb-4">
//           <h4 className="text-center mb-3">Round {summary.round}</h4>
//           <div className="row">
//             <div className="col-12 col-md-6">
//               <p className="fs-5 text-center">Total USDT Spent: {summary.totalSpentUSDT}</p>
//               <p className="fs-5 text-center">Total USDT Available: {summary.totalAvailableUSDT}</p>
//               <p className="fs-5 text-center">Total Referral Earned: {summary.totalReferral}</p>
//             </div>
//             <div className="col-12 col-md-6">
//               <p className="fs-5 text-center">Total BEE Spent: {summary.totalSpentBEE}</p>
//               <p className="fs-5 text-center">Total BEE Available: {summary.totalAvailableBEE}</p>
//             </div>
//           </div>
//         </div>
//       ))}

//       {/* Pagination Controls */}
//       <div className="text-center mt-3">
//         <button
//           className="btn btn-secondary me-2"
//           onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
//           disabled={currentPage === 1}
//         >
//           Previous
//         </button>
//         <span className="mx-2">Page {currentPage} of {userSummaries.length}</span>
//         <button
//           className="btn btn-secondary"
//           onClick={() => setCurrentPage((p) => Math.min(p + 1, userSummaries.length))}
//           disabled={currentPage === userSummaries.length}
//         >
//           Next
//         </button>
//       </div>

//           <div className="custom-table-container">
//             <table className="custom-table">
//               <thead>
//                 <tr>
//                   <th className="fw-bold">Round</th>
//                   <th className="fw-bold">Order No</th>
//                   <th className="fw-bold">Exit No</th>
//                   <th className="fw-bold">TXID</th>
//                   <th className="fw-bold">Copy</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {rows.length === 0 ? (
//                   <tr>
//                     <td colSpan="5" className="text-center">
//                       No transactions found
//                     </td>
//                   </tr>
//                 ) : (
//                   rows.slice(0, 11).map((row, idx) => {
//                     const shortTx = `${row.txid.slice(0, 10)}...${row.txid.slice(-6)}`;
//                     return (
//                       <tr key={idx}>
//                         <td>{row.round}</td>
//                         <td>{row.orderNo}</td>
//                         <td>{row.exitNo}</td>
//                         <td>
//                           {isBSC ? (
//                             <a
//                               href={`${bscScanBase}${row.txid}`}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                             >
//                               {shortTx}
//                             </a>
//                           ) : (
//                             shortTx
//                           )}
//                         </td>
//                         <td
//                           style={{ cursor: "pointer" }}
//                           onClick={() => {
//                             navigator.clipboard.writeText(row.txid);
//                             alert("TXID copied to clipboard");
//                           }}
//                         >
//                           <IoCopy style={{ color: "rgba(255, 217, 87, 1)" }} />
//                         </td>
//                       </tr>
//                     );
//                   })
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         <div className="col-12 col-md-2 flexx">
//           <img src={capbee} alt="" width={170} height={170} />
//           <img src={capbee22} alt="" className="w-100 mt-5" />
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Info;


////////////////////////////////  new code  //////////////////////////////

import React, { useEffect, useMemo, useState } from "react";
import { IoCopy } from "react-icons/io5";
import Web3 from "web3";
import { useWeb3ModalAccount } from "@web3modal/ethers/react";

import capbee from "../assets/Group 25.png";
import capbee2 from "../assets/6842a7f196a5b2b2149f793f6a3bebf0f3fa9777 (1).gif";
import smallbee from "../assets/8f3479b9762001f0370cb94e488635a5a1211592.gif";

import { beeplanABI, beeplanAddress } from "../Contract/BeePlan";
import { usdtTokenABI, usdtTokenAddress } from "../Contract/USDT";
import { beeTokenABI, beeTokenAddress } from "../Contract/BeeToken";

function Info() {
  const { address: account, chainId } = useWeb3ModalAccount();
  const isBSC = chainId === 97 || chainId === 56;
  const bscScanBase = chainId === 97
    ? "https://testnet.bscscan.com/tx/"
    : "https://bscscan.com/tx/";

    const web3 = useMemo(() => new Web3(window.ethereum), []);

  const beePlanContract = new web3.eth.Contract(beeplanABI, beeplanAddress);

  const [rows, setRows] = useState([]);
  const [userSummaries, setUserSummaries] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [roundss, setRoundss] = useState(0);
  const [loadingSummary, setLoadingSummary] = useState(true);
  const [loadingEvents, setLoadingEvents] = useState(true);
  
  const pageSize = 1; // one round per page

  // --- Fetch user summaries per round (unchanged) ---
  const fetchAllUserSummaries = async () => {
    try {
      setLoadingSummary(true);
      const currentRound = Number(await beePlanContract.methods.currentRound().call());
      setRoundss(currentRound);
  
      const fmt = v => Number(v) / 1e18;
      const summaries = [];
  
      for (let round = currentRound; round >= 1; round--) {
        const data = await beePlanContract.methods.getUserSummary(account, round).call();
        summaries.push({
          round,
          totalSpentUSDT: fmt(data.totalSpentUSDT),
          totalAvailableUSDT: fmt(data.totalAvailableUSDT),
          totalReferral: fmt(data.totalReferral),
          totalSpentBEE: fmt(data.totalSpentBEE),
          totalAvailableBEE: fmt(data.totalAvailableBEE),
        });
      }
  
      setUserSummaries(summaries);
      setCurrentPage(1);
    } catch (err) {
      console.error("Error fetching user summaries:", err);
    } finally {
      setLoadingSummary(false);
    }
  };
  

  useEffect(() => {
    if (account) {
      fetchAllUserSummaries();
    }
  }, [account]);

  // --- Fetch & display last-11 txs with ALL Purchase logs ---
  const fetchContractEvents = async () => {
    if (!account) return;
    try {
      setLoadingEvents(true);
      const latestBlock = Number(await web3.eth.getBlockNumber());
      const fromBlock = Math.max(0, latestBlock - 70000);
      let allEvents = [];
  
      for (let start = fromBlock; start <= latestBlock; start += 5000) {
        const end = Math.min(start + 4999, latestBlock);
        const evs = await beePlanContract.getPastEvents("Purchase", {
          filter: { user: account },
          fromBlock: start,
          toBlock: end
        });
        allEvents.push(...evs);
      }
  
      allEvents.sort((a, b) => {
        const byBlock = Number(b.blockNumber) - Number(a.blockNumber);
        if (byBlock !== 0) return byBlock;
        return Number(b.logIndex) - Number(a.logIndex);
      });
  
      const uniqueTxs = Array.from(new Set(allEvents.map(e => e.transactionHash))).slice(0, 11);
  
      const filtered = allEvents.filter(e => uniqueTxs.includes(e.transactionHash));
  
      const formatted = filtered.map(e => ({
        round: e.returnValues.round.toString(),
        orderNo: e.returnValues.queueId.toString(),
        exitNo: e.returnValues.exitTrigger.toString(),
        txid: e.transactionHash,
      }));
  
      setRows(formatted);
    } catch (error) {
      console.error("Error fetching contract events:", error);
    } finally {
      setLoadingEvents(false);
    }
  };
  
  

  useEffect(() => {
    fetchContractEvents(); // Initial call
    // const iv = setInterval(fetchContractEvents, 10000);

    return () => clearInterval();
  }, [account]);

  // pagination for summaries
  const paginatedSummaries = userSummaries.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  return (
    <div>
      <div className="row m-0 p-0">
        {/* left art */}
        <div className="col-12 col-md-2 p-0 flexx">
          <img src={capbee2} alt="" className="w-100 pt-5" />
          <img src={smallbee} alt="" className="smabeer mt-5" width={100} height={100} />
        </div>

        {/* center info */}
        <div className="col-12 col-md-8 tree">
          <h2 className="fw-bolder fs-1 text-center mb-3 mt-5 mt-md-1">
            My Information
          </h2>
          <p className="fs-5 text-center" style={{ letterSpacing: "1px", wordBreak: "break-all" }}>
            Wallet Address: {account || "Not connected"}
          </p>

          {loadingSummary ? (
  <div className="text-center my-4">
    <div className="spinner-border text-warning" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
) : (
  paginatedSummaries.map(summary => (
    <div key={summary.round} className="mb-4">
              <h4 className="text-center mb-3">Round {summary.round}</h4>
              <div className="row">
                <div className="col-6">
                  <p className="fs-5 text-center">USDT Spent: {summary.totalSpentUSDT}</p>
                  <p className="fs-5 text-center">USDT Available: {summary.totalAvailableUSDT}</p>
                  <p className="fs-5 text-center">Referral Earned: {summary.totalReferral}</p>
                </div>
                <div className="col-6">
                  <p className="fs-5 text-center">BEE Spent: {summary.totalSpentBEE}</p>
                  <p className="fs-5 text-center">BEE Available: {summary.totalAvailableBEE}</p>
                </div>
              </div>
              </div>
  ))
)}

          <div className="text-center mt-3">
            <button
              className="btn btn-secondary me-2"
              onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
              disabled={currentPage === 1}
            >Previous</button>
            <span className="mx-2">Page {currentPage} of {userSummaries.length}</span>
            <button
              className="btn btn-secondary"
              onClick={() => setCurrentPage(p => Math.min(p + 1, userSummaries.length))}
              disabled={currentPage === userSummaries.length}
            >Next</button>
          </div>

          <div className="custom-table-container mt-4">
          <div className="custom-table-container mt-4">
  {loadingEvents ? (
    <div className="text-center my-4">
      <div className="spinner-border text-warning" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  ) : (
    <table className="custom-table">
              <thead>
                <tr>
                  <th>Round</th>
                  <th>Order No</th>
                  <th>Exit No</th>
                  <th>TXID</th>
                  <th>Copy</th>
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="text-center">No transactions found</td>
                  </tr>
                ) : (
                  rows.map((row, idx) => {
                    const shortTx = `${row.txid.slice(0, 10)}...${row.txid.slice(-6)}`;
                    return (
                      <tr key={`${row.txid}-${idx}`}>
                        <td>{row.round}</td>
                        <td>{row.orderNo}</td>
                        <td>{row.exitNo}</td>
                        <td>
                          {isBSC ? (
                            <a
                              href={`${bscScanBase}${row.txid}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {shortTx}
                            </a>
                          ) : shortTx}
                        </td>
                        <td
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            navigator.clipboard.writeText(row.txid);
                            alert("TXID copied to clipboard");
                          }}
                        >
                          <IoCopy style={{ color: "rgba(255, 217, 87, 1)" }} />
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
             )}
</div>
          </div>
        </div>

        {/* right art */}
        <div className="col-12 col-md-2 flexx">
          <img src={capbee} alt="" width={170} height={170} />
          <img src={capbee2} alt="" className="w-100 mt-5" />
        </div>
      </div>
    </div>
  );
}

export default Info;
